import { createContext } from 'react';

export const DateRangeContext = createContext({
  filterType: 'none',   // today | yesterday | last7 | month | custom | none
  start: '',            // yyyy-mm-dd  (for custom)
  end:   '',            // yyyy-mm-dd
});
